import React, { useEffect } from "react";
import LoginComponent from "../components/login/LoginComponent";
import { useNavigate, useSearchParams } from "react-router-dom";
import ResetPassword from "../components/login/ResetPassword";
import OtpScreen from "../components/login/OtpScreen";
import NewPasswordScreen from "../components/login/NewPasswordScreen";
import { getToken } from "../constants/apis/communication";

export default function Login() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const currentPage = searchParams.get("page");
  const isTokenExist = getToken();

  useEffect(() => {
    if (isTokenExist) {
      navigate("/panel");
    }
  }, [isTokenExist]);

  return <div>{currentPage === "reset" ? <ResetPassword /> : currentPage === "otp" ? <OtpScreen /> : currentPage === "new-password" ? <NewPasswordScreen /> : <LoginComponent />}</div>;
}
